import { State, City } from 'country-state-city';

const statesOfIndia = State.getStatesOfCountry('IN');
const citiesOfIndia = City.getCitiesOfCountry('IN');

export const INDIAN_STATES = statesOfIndia.map(s => s.name);

// Generate formatted locations: "City, State, India"
const formattedCities = citiesOfIndia.map(city => {
    const state = statesOfIndia.find(s => s.isoCode === city.stateCode);
    const stateName = state ? state.name : '';
    return stateName ? `${city.name}, ${stateName}, India` : `${city.name}, India`;
});

// Generate formatted locations: "State, India"
const formattedStates = INDIAN_STATES.map(state => `${state}, India`);

// Combine and avoid duplicates
export const ALL_LOCATIONS = [...new Set([...formattedCities, ...formattedStates])].sort();
